module.exports = __webpack_public_path__ + "static/media/duanwuBg1.f662e79b.png";